<template>
  <el-table
    :data="couponDetails"
    border
    style="width: 100%"
    class="table"
  >
    <el-table-column
      prop="detailId"
      :label="$t('couponDetail.detailId')"
      align="center"
    />
    <el-table-column
      prop="couponName"
      :label="$t('couponDetail.couponName')"
      align="center"
    />
    <el-table-column
      prop="actualPrice"
      :label="$t('couponDetail.faceValue')"
      align="center"
    />
    <el-table-column
      prop="buyPrice"
      :label="$t('couponDetail.purchasePrice')"
      align="center"
    />
    <el-table-column
      prop="amount"
      :label="$t('couponDetail.paymentAmount')"
      align="center"
    />
    <el-table-column
      prop="buyCount"
      :label="$t('couponDetail.purchaseQuantity')"
      align="center"
    />
    <el-table-column
      prop="validityDay"
      :label="$t('couponDetail.validityPeriod')"
      align="center"
    />
    <el-table-column
      prop="createTime"
      :label="$t('couponDetail.purchaseTime')"
      align="center"
    />
  </el-table>
</template>

<script>
export default {
  name: 'CouponDetailManageTable',
  props: {
    couponDetails: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>